import React from 'react';
import SalesHunterGame from './components/SalesHunterGame';
import './App.css';

function App() {
  return (
    <div className="app-container">
      <SalesHunterGame />
    </div>
  );
}

export default App;